import { RichTextToolbarButton } from '@digitale-menschen/component-library';

/**
 * The toolbar every richtext field in the user app offers — an Aufgabe's Beschreibung in both
 * create dialogs and in its drawer, and every Notiz editor.
 *
 * One set on purpose: a Beschreibung and a Notiz end up next to each other in the Verlauf, and
 * a Notiz written on an Aufgabe sits beside one written on an Anforderung, so a button
 * available in one and missing in the other reads as a bug.
 */
export const RICHTEXT_TOOLBAR_BUTTONS: RichTextToolbarButton[] = [
  'bold',
  'italic',
  'underline',
  'highlight',
  'alignment',
  'bulletList',
  'link',
];
